/* RESPONSIBLE TEAM: team-proactive-support */
import NodeConfiguration, { NODE_CATEGORIES } from 'embercom/objects/series/node-configuration';
import SMSInserterConfiguration from 'embercom/objects/series/node/sms-inserter-configuration';

export default class SMSNodeConfiguration extends NodeConfiguration {
  inserterConfiguration = new SMSInserterConfiguration();
  category = NODE_CATEGORIES.content;
}
